/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EReviewStatus } from './EReviewStatus';
import {
    EReviewStatusFromJSON,
    EReviewStatusFromJSONTyped,
    EReviewStatusToJSON,
    EReviewStatusToJSONTyped,
} from './EReviewStatus';

/**
 * 
 * @export
 * @interface UpsertReviewNotePayloadDto
 */
export interface UpsertReviewNotePayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertReviewNotePayloadDto
     */
    underwritingNotes?: string;
    /**
     * Review status
     * @type {EReviewStatus}
     * @memberof UpsertReviewNotePayloadDto
     */
    reviewStatus?: EReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof UpsertReviewNotePayloadDto
     */
    peerReviewNotes?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpsertReviewNotePayloadDto
     */
    approvedDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertReviewNotePayloadDto
     */
    fileIds?: Array<string>;
}



/**
 * Check if a given object implements the UpsertReviewNotePayloadDto interface.
 */
export function instanceOfUpsertReviewNotePayloadDto(value: object): value is UpsertReviewNotePayloadDto {
    return true;
}

export function UpsertReviewNotePayloadDtoFromJSON(json: any): UpsertReviewNotePayloadDto {
    return UpsertReviewNotePayloadDtoFromJSONTyped(json, false);
}

export function UpsertReviewNotePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertReviewNotePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'underwritingNotes': json['underwritingNotes'] == null ? undefined : json['underwritingNotes'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : EReviewStatusFromJSON(json['reviewStatus']),
        'peerReviewNotes': json['peerReviewNotes'] == null ? undefined : json['peerReviewNotes'],
        'approvedDate': json['approvedDate'] == null ? undefined : (new Date(json['approvedDate'])),
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function UpsertReviewNotePayloadDtoToJSON(json: any): UpsertReviewNotePayloadDto {
    return UpsertReviewNotePayloadDtoToJSONTyped(json, false);
}

export function UpsertReviewNotePayloadDtoToJSONTyped(value?: UpsertReviewNotePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'underwritingNotes': value['underwritingNotes'],
        'reviewStatus': EReviewStatusToJSON(value['reviewStatus']),
        'peerReviewNotes': value['peerReviewNotes'],
        'approvedDate': value['approvedDate'] == null ? undefined : ((value['approvedDate']).toISOString()),
        'fileIds': value['fileIds'],
    };
}

